import { useState, createContext, useContext, useMemo } from 'react';
import type { DescriptionPanelId } from 'balus-common';

type EditingDescriptionPanelContextType = {
  editingPanelId: DescriptionPanelId | null;
  setEditingPanelId(editingPanelId: DescriptionPanelId | null): void;
};

const EditingDescriptionPanelContext = createContext<EditingDescriptionPanelContextType>({
  editingPanelId: null,
  setEditingPanelId: () => {},
});

type Props = {
  children: React.ReactNode;
};

export const EditingDescriptionPanelContextProvider: React.FC<Props> = ({ children }: Props) => {
  const [editingPanelId, setEditingPanelId] = useState<DescriptionPanelId | null>(null);

  const value = useMemo(() => ({ editingPanelId, setEditingPanelId }), [editingPanelId, setEditingPanelId]);

  return <EditingDescriptionPanelContext.Provider value={value}>{children}</EditingDescriptionPanelContext.Provider>;
};

export const useEditingDescriptionPanel = (): EditingDescriptionPanelContextType => {
  const { editingPanelId, setEditingPanelId } = useContext(EditingDescriptionPanelContext);
  return { editingPanelId, setEditingPanelId };
};
